import { Button, Stack } from "react-bootstrap";
import clsx from "classnames";
import classes from "./styles.module.scss";
import { trimText } from "@/functions/trimText";
import { DynamicText } from "@/ui/DynamicText";
import { useLocale } from "@/hooks/useLocale";
import { useLink } from "@/hooks/useLink";
import Logo from "@/assets/LogoDarkEN.svg";

export const InsightItem = ({ item }) => {
  const locale = useLocale();
  const link = useLink();
  const href = link(`blog.item`, locale === "en" ? item.url_slug : item[`url_${locale}`]);

  return (
    <div className="ps-md-5 ms-md-4">
      <Stack className={clsx(classes.item, "flex-md-row py-md-4 pe-md-4 mb-4")}>
        <a className={classes.img} href={href}>
          {item.image ? (
            <img src={item.image} alt={item?.image_alt ?? ""} />
          ) : (
            <div className="ratio ratio-1x1 bg-white border">
              <div className="d-flex align-items-center p-3">
                <Logo className="w-100" />
              </div>
            </div>
          )}
        </a>
        <div className="py-3 px-3 ps-md-0">
          <h3 className="h5 mb-4" dangerouslySetInnerHTML={{ __html: item[`title_${locale}`] }} />
          <div className="pb-3 mb-md-4" dangerouslySetInnerHTML={{ __html: trimText(item[`text_${locale}`], 100) }} />
          <div className="d-flex justify-content-start">
            <Button variant="outline-primary" href={href} tabIndex={undefined}>
              <DynamicText path={`page.insights.item.button.${locale}`} />
            </Button>
          </div>
        </div>
      </Stack>
    </div>
  );
};
